import React, { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import MainHeading from "../../../components/comman/MainHeading";
import EditIcon from "../../../components/Icons/EditIcon";
import { toast } from "react-toastify";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { useNavigate } from "react-router-dom";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function Company() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [selectedId, setSelectedId] = useState("");
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CompanyList: [],
    searchQuery: "",
  });
  const getCompany = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_company + "?" + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.company?.map((item) => ({
          ...item,
          toggleStatus: item?.status,
          companylogo: item?.documents?.find(
            (item) => item?.name === "Company_Logo"
          )?.url,
        }));

        setPageStates((pre) => ({
          ...pre,
          CompanyList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "companylogo", label: "Company Logo" },
    { value: "name", label: "Company Name" },
    { value: "shortName", label: "Short Name" },
    { value: "email", label: "Company Email" },
    { value: "phone", label: "Contact Number" },
    { value: "gst", label: "GST Number" },
    { value: "toggleStatus", label: "Status" },
  ];

  useEffect(() => {
    getCompany();
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates.pageSize, filterDetails?.orderBy]);

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const handleStatusToggle = (data, status) => {
    const formdata = new FormData();
    formdata?.append("status", status ? 0 : 1);

    const options = {
      method: "POST",
      form_data: formdata,
    };
    let API = apiUrl?.add_company + `?companyId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        getCompany(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggle();
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_company, { state: { EditData: data } });
  };

  const redirectToView = (data) => {
    navigate(RoutesLink.company_detail + `/${data?.id}`);
  };

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: redirectToView,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      {/* <> */}
      <div className="content">
        <MainHeading
          title={"Company"}
          buttonText={"Add Company"}
          buttonIcon={<PlusIcon />}
          buttonLink={RoutesLink.add_company}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              tableDataForExport={pageStates?.CompanyList}
              exportFileName={"Company_Data"}
              exportColumns={["name", "email", "phone", "gst"]}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.CompanyList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
              handleStatusToggle={handleStatusToggle}
            />
          </div>
        </div>
      </div>
      {/* </> */}
    </>
  );
}
